import React from "react"
import { AppBar, Grid, Toolbar } from "@material-ui/core"
import HeaderLogo from "molecules/HeaderLogo"

const Header = () => {
  return (
    <AppBar color="inherit" position="relative">
      <Toolbar>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Grid container justifyContent="flex-start" alignItems="center">
              <Grid item>
                <HeaderLogo />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  )
}

export default Header
